import { LayoutGrid, List, Table2 } from "lucide-react"

import { SegmentedControl, type SegmentedOption } from "../ui/segmented-control"

// How the feed preview is rendered: the raw CSV `feed` table, or a
// storefront-style `grid`/`table` that mirrors how the listing looks on the
// marketplace — so off titles/images are obvious at a glance.
export type FeedViewMode = "feed" | "grid" | "table"

const MODES: readonly SegmentedOption<FeedViewMode>[] = [
  { value: "feed", label: "Feed", icon: Table2 },
  { value: "grid", label: "Grid", icon: LayoutGrid },
  { value: "table", label: "Table", icon: List },
]

export function FeedViewModeTabs({
  value,
  onChange,
}: {
  value: FeedViewMode
  onChange: (value: FeedViewMode) => void
}) {
  return (
    <SegmentedControl options={MODES} value={value} onChange={onChange} label="Feed view mode" />
  )
}
